
import { useEffect, useState } from "react";
import AvisosService from "../services/AvisosService";

export function useAviso(ids) {
  const [avisos, setAvisos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    async function carregar() {
      try {
        setLoading(true);

        if (Array.isArray(ids)) {
          
          const resultados = await Promise.all(
            ids.map(id => AvisosService.getById(id))
          );
          setAvisos(resultados);
        } else {
          
          const aviso = await AvisosService.getById(ids);
          setAvisos([aviso]);
        }
      } catch (e) {
        setErro("Erro ao buscar avisos");
      } finally {
        setLoading(false);
      }
    }

    carregar();
  }, [ids]);

  return { avisos, loading, erro };
}
